import { useContext, useState, useEffect } from 'react';
import { AdminUsersDataContext } from '../../contexts/AdminUsersDataContext';import UserService from '../../services/UserService';
import { iUser } from '../../contexts/UserContext';
import userService from '../../services/UserService';
import DashboardCenterSettings from '../DashboardCenterSettings';
import { BackToUsersLink } from  '../AdminCenterUsers';
import KeycloakService from '../../services/KeycloakService';

const InstitutionUserEdit = () => {
    const [user,setUser] = useState<iUser | null | undefined>(null);
    const { institutionUser, isInstitutionUsersDataLoaded, selectedUserType } = useContext(AdminUsersDataContext); // 
    const [ isReadOnly, setIsReadOnly ] = useState(false);
    useEffect(() => {
        if (['Admin', 'Manager', 'InstitutionAdmin'].some(g => KeycloakService.hasGroup([g]))) {
            setIsReadOnly(false);
        } else {
            setIsReadOnly(true);
        }
    }, []);

    useEffect(() => {
        fetchUser();
    }, [isInstitutionUsersDataLoaded, institutionUser?.authId]);

    const fetchUser = async () => {
        if (isInstitutionUsersDataLoaded && institutionUser?.authId) {
            await userService.GetUser(institutionUser?.authId, (v) => { }, true).then((result) => {
                setUser(userService.MapToUser(result));
            })
        }
    };

    return (
        <div>
            <BackToUsersLink />
            {institutionUser && <DashboardCenterSettings isAdminEdit={true} user={user} updateUser={(user) => { setUser(userService.MapToUser(user)) }} selectedUserType={selectedUserType} isReadOnly={isReadOnly} />}
        </div>
    );
};

export default InstitutionUserEdit;